export const INPUT_CHECKBOX = 'checkbox';
export const INPUT_RADIO = 'radio';
export const INPUT_TEXT = 'text';
export const SUPPORTED_LAYOUTS = ['column', 'row'];
export const SUPPORTED_TYPES = [INPUT_CHECKBOX, INPUT_RADIO, INPUT_TEXT];

export default { INPUT_CHECKBOX, INPUT_RADIO, INPUT_TEXT, SUPPORTED_LAYOUTS, SUPPORTED_TYPES };
